import axios from '@/libs/api.request'

export const login = ({ userName, password, smsCode, google2faCode }) => {
    const data = {
        userName,
        password,
        smsCode,
        google2faCode
    }
    return axios.request({
        url: '/shop/index/login',
        data,
        method: 'post'
    })
}

export const getUserInfo = (token) => {
    return axios.request({
        url: '/shop/user/getUserInfo',
        params: {
            token
        },
        method: 'get'
    })
}

export const getUserList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/getUserList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const switchAccound = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/switchAccound',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getRoleList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/getRoleList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

export const getDepartmentList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/getDepartmentList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getTeamList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/getTeamList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

export const logout = (token) => {
    return axios.request({
        url: 'logout',
        method: 'post'
    })
}
//保存用户的充值信息
export const saveUserRechargeInfo = (data) => {
    return axios.request({
        url: '/shop/user/saveUserRechargeInfo',
        data,
        method: 'post'
    })
}
//获取商户下所有用户的流水信息
export const getAllUserBillInfoInShop = (data) => {
    return axios.request({
        url: '/shop/user/getUserBillInShop',
        data,
        method: 'post'
    })
}

export const deleteRole = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/deleteRole',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

export const saveRole = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/saveRole',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

export const getUserByRole = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/getUserByRole',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

export const getPermission = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/getPermission',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const savePermission = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/savePermission',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getRoleLog = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/getRoleLog',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getDepartmentLog = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/getDepartmentLog',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

export const saveDepartment = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/saveDepartment',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

export const delDepartment = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/delDepartment',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getMemberByDepartment = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/getMemberByDepartment',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

export const getDepartmentTree = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/getDepartmentTree',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

export const getDepartmentTreeTest = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/getDepartmentTreeTest',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

export const manageUser = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/manageUser',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const deleteUser = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/deleteUser',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}


//更新用户中心的用户信息
export const changeUserInfo = async (data) => {
    return axios.request({
        url: '/shop/user/changeUserInfo',
        data,
        method: 'post'
    })
}

//获取用户中心数据

export const getUserCenterInfo = async (data) => {
    return axios.request({
        url: '/shop/user/getUserCenterInfo',
        data,
        method: 'post'
    })
}

export const getUpgrade = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/getUpgrade',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

// 全部已读
export const allRead = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/allRead',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

//获取用户菜单上徽章数量
export const getUserBadgeCountInfo = async (data) => {
    return axios.request({
        url: '/shop/user/getUserBadgeCountInfo',
        data,
        method: 'post'
    })
}

// 获取我的所有部门
export const getMyDepartmentList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/getMyDepartmentList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
// 设置数据开关
export const setDataSetOpen = async (that, data) => {
    var res = await axios.request({
        url: '/app/user/setDataSetOpen',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

// 获取我的客户提示
export const getMyClientTips = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/getMyClientTips',
        data,
        method: 'post'
    })
    res = res.data;
    return res;
}
// 获取我的客户预约提示
export const getMyAppointment = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/getMyAppointment',
        data,
        method: 'post'
    })
    res = res.data;
    return res;
}
// 获取我的客户提示
export const getRepeatClientTips = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/getRepeatClientTips',
        data,
        method: 'post'
    })
    res = res.data;
    return res;
}
// 获取我的公告
export const getAnnounce = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/getAnnounce',
        data,
        method: 'post'
    })
    res = res.data;
    return res;
}
export const getDepartmentListByShopId = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/getDepartmentListByShopId',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

export const getUserListByDepartmentId = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/getUserListByDepartmentId',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

export const getWhiteLoginUserList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/getWhiteLoginUserList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

export const getAllUserList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/getAllUserList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

export const saveWhiteLoginUser = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/saveWhiteLoginUser',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getMsg = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/getMsg',
        data,
        method: 'post'
    })
    res = res.data;
    return res;
}
export const getAllMsg = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/getAllMsg',
        data,
        method: 'post'
    })
    res = res.data;
    return res;
}
export const setIsFlush = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/setIsFlush',
        data,
        method: 'post'
    })
    res = res.data;
    return res;
}
export const checkPublicPoolPassword = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/checkPublicPoolPassword',
        data,
        method: 'post'
    })
    res = res.data;
    return res;
}
export const unBoundOTP = async (that, data) => {
    var res = await axios.request({
        url: '/shop/totp/unBoundOTP',
        data,
        method: 'post'
    })
    res = res.data;
    return res;
}